<template>
  <div class="product-preview">
    <button class="btn-back" @click="$emit('close')">
      <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M5.2903 0.387101L5.20711 0.292893C4.84662 -0.0675907 4.27939 -0.0953203 3.8871 0.209705L3.79289 0.292893L0.792893 3.29289L0.751496 3.33685L0.696335 3.40469L0.624671 3.51594L0.571225 3.62866L0.535845 3.73401L0.506907 3.8819L0.5 4L0.502788 4.07524L0.52024 4.20073L0.549738 4.31214L0.593673 4.42322L0.645995 4.52071L0.719689 4.62545L0.792893 4.70711L3.79289 7.70711C4.18342 8.09763 4.81658 8.09763 5.20711 7.70711C5.56759 7.34662 5.59532 6.77939 5.2903 6.3871L5.20711 6.29289L3.915 5L11.5 5C12.0523 5 12.5 4.55228 12.5 4C12.5 3.44772 12.0523 3 11.5 3L3.915 3L5.20711 1.70711C5.56759 1.34662 5.59532 0.779392 5.2903 0.387101L5.20711 0.292893L5.2903 0.387101Z"
              fill="#3C3C3C"/>
      </svg>
      Cofnij
    </button>
    <div class="inner" data-simplebar>
      <div class="product-images-wrap" :class="{ desktop : !isMobile }">
        <VueSlickCarousel v-bind="settings" v-if="isMobile">
          <div class="image" v-for="image in product.images">
            <img :src="image"/>
          </div>
        </VueSlickCarousel>
        <div class="image" v-for="image in product.images" v-else>
          <img :src="image"/>
        </div>
      </div>
      <div class="product-info">
        <div class="name">
          <h4>{{ product.name }}</h4>
          <p style="margin: 10px 0; line-height: 20px;">{{ product.description }}</p>
        </div>
        <a class="btn-href" :href="product.link" target="_blank">
          Zobacz pełen opis produktu
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.0001 0.599976H4.6001C5.04193 0.599976 5.4001 0.958148 5.4001 1.39998C5.4001 1.81024 5.09127 2.14838 4.69339 2.19459L4.6001 2.19998H3.0001C2.58983 2.19998 2.25169 2.50881 2.20548 2.90668L2.2001 2.99998V11C2.2001 11.4102 2.50893 11.7484 2.9068 11.7946L3.0001 11.8H11.0001C11.4104 11.8 11.7485 11.4911 11.7947 11.0933L11.8001 11V9.39997C11.8001 8.95815 12.1583 8.59998 12.6001 8.59998C13.0104 8.59998 13.3485 8.90881 13.3947 9.30668L13.4001 9.39997V11C13.4001 12.2781 12.401 13.3229 11.1411 13.3959L11.0001 13.4H3.0001C1.72195 13.4 0.677169 12.4008 0.604172 11.141L0.600098 11V2.99998C0.600098 1.72183 1.59923 0.677047 2.85908 0.60405L3.0001 0.599976H4.6001H3.0001ZM12.6001 0.599976L12.6649 0.602376L12.7607 0.616168L12.8498 0.639766L12.9387 0.674914L13.0167 0.716772L13.0935 0.770204L13.1658 0.83429L13.243 0.92373L13.3004 1.01273L13.3252 1.0615L13.3522 1.12666L13.3714 1.18718L13.3946 1.3055L13.4001 1.39998V4.59998C13.4001 5.0418 13.0419 5.39998 12.6001 5.39998C12.1583 5.39998 11.8001 5.0418 11.8001 4.59998V3.33118L8.36578 6.76566C8.0774 7.05405 7.62361 7.07623 7.30978 6.83221L7.23441 6.76566C6.94602 6.47727 6.92384 6.02349 7.16786 5.70966L7.23441 5.63429L10.6673 2.19998H9.4001C8.95827 2.19998 8.6001 1.8418 8.6001 1.39998C8.6001 0.958148 8.95827 0.599976 9.4001 0.599976H12.6001Z"
                  fill="#3C3C3C"/>
          </svg>
        </a>
      </div>

      <div class="product-features-wp" style="margin-top: 20px;">
        <div class="feature" v-for="feature in product.features">
          <div class="icon"><img :src="feature.icon"/></div>
          <div class="caption">
            <h5>{{ feature.title }}</h5>
            <p>{{ feature.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import clickOutside from '../../directives/clickOutside'

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: "ProductComplementaryPreview",
  components: {VueSlickCarousel},
  props: {
    product: {
      type: Object
    }
  },
  directives: {
    clickOutside: clickOutside
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      settings: {
        arrows: false,
        dots: true,
        mobileFirst: true,
        infinite: false
      }
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 996
    }
  },
  methods: {
    renderHTML(str) {
      let txt = document.createElement('textarea')
      txt.innerHTML = str
      return txt.value
    },
    closeDialog() {
      if (this.attribute.addToCart) {
        this.$emit('closeAll')
      } else {
        this.$emit('close')
      }
    }
  },
  mounted() {
    this.windowWidth = window.innerWidth

    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>

<style scoped lang="scss">
.product-preview {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  z-index: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 480px) {
    position: fixed;
  }

  .btn-back {
    border: 0;
    margin: 0;
    background: none;
    font-weight: 600;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 25px;
    color: #000;


    svg {
      margin: 0 10px 0 0;
    }
  }

  .inner {
    padding: 0 25px 0 25px;
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
  }

  .product-images-wrap {
    margin-bottom: 30px;

    &.desktop {
      margin: 0 0 15px 0;
      display: flex;
      justify-content: space-between;
      gap: 10px;
    }

    img {
      max-width: 100%;
      height: auto;
    }

  }

  .product-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (min-width: 320px) and (max-width: 768px) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: baseline;
    }
    .name {
      h4 {
        margin: 0;
        font-size: 16px;
        color: #000;
      }

      p {
        font-size: 12px;
        font-weight: normal;
        color: #969696;
        margin: 0;
      }
    }

    .btn-href {
      padding: 8px 14px;
      display: inline-flex;
      align-items: center;
      background: #fff;
      border: 1px solid #252525;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 600;
      transition: all .2s;
      cursor: pointer;
      line-height: 1;
      color: #3C3C3C;
      text-decoration: none;
      white-space: nowrap;
      margin-left: 15px;

      @media (max-width: 768px) {
        margin: 10px 0 20px 0;
        width: 100%;
        box-sizing: border-box;
        justify-content: center;
      }

      &:hover {
        background: #252525;
        color: #fff;

        svg path {
          fill: #fff;
        }
      }

      @media (max-width: 768px) {
        padding: 8px 12px;
        max-width: 100%;
      }

      svg {
        margin: 0 0 0 10px;
      }
    }
  }

  .product-description {
    margin: 25px 0;
    color: #969696;
    font-size: 12px;
    line-height: 16px;
    max-width: 70%;
    @media (max-width: 768px) {
      max-width: 100%;
    }
  }

  .product-features-wp {
    display: flex;
    flex-wrap: wrap;

    @media (max-width: 480px) {
      flex-direction: column;
    }

    .feature {
      display: flex;
      margin-bottom: 30px;
      justify-content: space-between;
      align-items: center;
      width: 50%;
      @media (max-width: 768px) {
        width: 100%;
        margin-bottom: 15px;
      }

      .icon {
        width: 30%;
        text-align: center;
      }

      .caption {
        width: 70%;

        h5 {
          font-weight: 600;
          font-size: 16px;
          line-height: 18px;
          color: #000;
          margin: 0 0 5px 0;
        }

        p {
          font-size: 12px;
          line-height: 16px;
          font-weight: normal;
          color: #969696;
          margin: 0;
        }
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
}
</style>
